import React from 'react';
import { useDrag } from 'react-dnd';

function PageBreak() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'page_break' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div className="card mb-2">
    <div
      ref={drag}
      style={{
        cursor: 'move',
        opacity: isDragging ? 0.1 : 1
      }}
      className="card-body p-2 bg-white">
      Page Break
    </div>
  </div>
}

export default PageBreak;